import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { wbRouting } from './wb.routing';
import { WBComponent } from './wb.component';
import { GraphicWbComponent } from './graphic/graphic-wb.component';
import { FabricWbComponent } from './fabric/fabric-wb.component';
import { WelcomeWbComponent } from './welcome/wb-welcome.component';
import { AlgebraWbComponent } from './algebra/algebra-wb.component';
import { GeometryWbComponent } from './geometry/geometry-wb.component';
import { GeometryToolsComponent } from './geometry/geometry-tools.component';
import { LinkYoutubeWbComponent } from './links/link-youtube-wb.component';
import { MediaWbComponent } from './media/media-wb.component';
import { DesksMenuComponent } from './desksmenu/desks-menu.component';
import { AlgebraToolsComponent } from './algebra/algebra-tools.component';
import { TeacherWbComponent } from './teacher/teacher-wb.component';
import {CodeWbComponent} from './code/code-wb.component';
import {TextWbComponent} from './text/text-wb.component';
import {GeogebraWbComponent} from './geogebra/geogebra.component';
import { WbStatusComponent } from './wb-status.component'
import { AddTaskComponent } from './tools/add-task.component';
import { ShareScreenComponent } from './tools/share-screen.component';
import { MediaControlComponent } from './tools/media-control.component';
import { PeersComponent } from './peers/peers.component';
import { PeerComponent } from './peers/peer.component';
import { SessionsComponent } from './tools/sessions.component';
import { ToolsComponent } from './tools/tools.component';
import { CloseComponent } from './tools/close.component';
import { MaterialsComponent } from './tools/materials.component';
import { PeerToolsComponent } from './tools/peer-tools.component';
import { ModalModule } from "ngx-modal";
import { ButtonComponent } from '../utils/button/button.component';
import { MenuComponent } from '../utils/menu/menu.component';
import { IconMenuComponent } from '../utils/menu/icon-menu.component';
import { DndModule } from 'ng2-dnd'

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ChatComponent } from './chat/chat.component';

import { ChatWbComponent } from './chatwb/chat-wb.component';
import { PlayerComponent } from './player/player.component';
import { TranslateModule } from 'ng2-translate/ng2-translate';
import { ContentComponent } from './tools/content.component';
import { PlayerManagerComponent } from './tools/player-manager.component';
import { SliderModule } from 'primeng/primeng';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { Ng2BootstrapModule } from 'ngx-bootstrap';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ButtonsModule } from 'ngx-bootstrap/buttons';

import { TechCheckComponent } from '../tech-check/tech-check.component';

import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { FullRoomComponent } from './full-room.compoenent';
import { NotReadyRoomComponent } from './not-ready-room.component';
@NgModule({
  imports: [BrowserAnimationsModule, wbRouting,
    BsDropdownModule.forRoot(), ButtonsModule.forRoot(), TooltipModule.forRoot(), ProgressbarModule.forRoot(),
    CommonModule, ModalModule, FormsModule, ReactiveFormsModule,DndModule.forRoot(),

    TranslateModule, SliderModule],
  declarations: [
    PeersComponent, ToolsComponent, PeerComponent, ButtonComponent, IconMenuComponent, MenuComponent, 
    FullRoomComponent, NotReadyRoomComponent,
    AlgebraWbComponent, TeacherWbComponent, AlgebraToolsComponent, WbStatusComponent, GraphicWbComponent, TechCheckComponent,
    MediaWbComponent,GeometryToolsComponent, FabricWbComponent,GeometryWbComponent,  LinkYoutubeWbComponent,
    PlayerComponent, PlayerManagerComponent,  TextWbComponent, GeogebraWbComponent,
    AddTaskComponent,
    MediaControlComponent, ShareScreenComponent, PeerToolsComponent, CloseComponent, WBComponent, WelcomeWbComponent,
    MaterialsComponent, SessionsComponent,  DesksMenuComponent, 
    ChatWbComponent, ChatComponent,  ContentComponent, CodeWbComponent,],
  exports: [CommonModule, SliderModule]

})
export class WBModule {

}


// WEBPACK FOOTER //
// /app/src/app/wb/wb.module.ts